import React, { useCallback, useRef, useState } from 'react';
import _size from 'lodash/size';
import { useDispatch, useMappedState } from 'redux-react-hook';
import { updateFreeTextAnswer } from 'redux/actions/consultation/answer';
import TextField, { CharacterCounter } from 'styles/blocks/textField';
import Question from 'styles/blocks/question';
import { useAutoFocus } from 'common/customHooks';
import { NextButton } from '../nextButton';

export function FreeText({ isInvalid, questionId, questionText, questionGuidanceScript, isMounted, onClickNextQuestion, isGuidanceTextShownAboveQuestion }) {
  const mapState = useCallback(state => ({
    freeTextAnswer: state.consultationReducer.freeTextAnswer,
    maxAnswerLength: state.consultationReducer.question.maxLength,
    optional: state.consultationReducer.question.optional,
    inputsReadOnly: state.consultationReducer.inputsReadOnly,
  }), []);
  const { freeTextAnswer, maxAnswerLength, optional, inputsReadOnly } = useMappedState(mapState);

  // actions to update value
  const dispatch = useDispatch();
  const [text, setText] = useState(freeTextAnswer);
  const [maxLength] = useState(maxAnswerLength);
  const [isOptional] = useState(optional);

  const updateFreeText = updatedText => {
    setText(updatedText);
    return dispatch(updateFreeTextAnswer(updatedText));
  };

  const inputRef = useRef();
  useAutoFocus(true, isMounted, inputRef);

  const isNextButtonDisabled = !text && !isOptional;
  const answerLength = _size(text);

  function createMarkup(html) {
    return { __html: html };
  }

  return (
    <TextField>
      {maxLength && (
        <CharacterCounter answerLength={answerLength} maxLength={maxLength} id="max-char-label" />
      )}
      <TextField.Textarea
        value={text}
        onChange={event => updateFreeText(event.target.value)}
        isInvalid={isInvalid}
        ref={inputRef}
        aria-label={questionText}
        aria-describedby="max-char-label"
        readOnly={inputsReadOnly}
      />
      {questionGuidanceScript && !isGuidanceTextShownAboveQuestion && <Question.ETriageHelpLabel dangerouslySetInnerHTML={createMarkup(questionGuidanceScript)} />}
      <NextButton dataAutomation={`nextButton-${questionId}`} onClick={onClickNextQuestion} isDisabled={isNextButtonDisabled} />
    </TextField>
  );
}
